import React from "react";

/** Catches ChunkLoadError after a redeploy (stale index.html asking for deleted chunks). */
export class ChunkErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    const msg = `${error?.name || ""} ${error?.message || ""}`;
    if (/ChunkLoadError|Loading chunk|dynamically imported module|Importing a module script failed/i.test(msg)) {
      if (!sessionStorage.getItem("chunk-reloaded")) {
        sessionStorage.setItem("chunk-reloaded", "1");
        window.location.reload();
      }
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center" data-testid="chunk-error">
        <p className="font-display text-xl">This page just updated.</p>
        <p className="text-sm text-slate-500">Reload to get the latest version.</p>
        <button onClick={() => { sessionStorage.removeItem("chunk-reloaded"); window.location.reload(); }}
          data-testid="chunk-error-reload"
          className="mt-1 border border-black/20 px-4 py-2 text-sm hover:border-klein">Reload</button>
      </div>
    );
  }
}

export default ChunkErrorBoundary;
